import React from 'react'

import Page from '../../../../components/pdf/Page'
import PropostaTemplate from './templates/PropostaTemplate'
import Header from './Header'

const PdfDocument = ({ templateId }) => {
  return (
    <Page header={<Header />}>
      <PropostaTemplate templateId={templateId} />
    </Page>
  )
}

export default PdfDocument
